<template>
    <div>
        <div class="row">
            <div class="col">
                <div class="card bg-secondary">
                    <div class="card-header border-0 table-responsive">
                        <table class="table align-items-center table-striped table-bordered">
                            <thead class="background-blue">
                                <tr class="">
                                    <!-- <th class="text-center">FECHA|HORA TICKET</th> -->
                                    <th class="text-center">PATENTE</th>
                                    <th class="text-center">TICKET</th>
                                    <th class="text-center">GUIA</th>
                                    <th class="text-center">FECHA|HORA INGRESO</th>
                                    <th class="text-center">PROVEEDOR</th>
                                    <!-- <th class="text-center">SUCURSAL</th> -->
                                    <th class="text-center">MATERIA PRIMA</th>
                                    <th class="text-center">ESPECIE</th>
                                    <th class="text-center">RESTRICCION</th>
                                    <th class="text-center">ESTADO</th>


                                </tr>
                            </thead>
                            <tbody class="list">

                                <tr v-for="(item, index) in lista" :key="index"
                                    v-bind:class="{ 'bg-salmon': tiene_restriccion(item.restriccion) }">
                                    <!-- <td class="text-center">{{item.fecha_hora_ticket}}</td> -->
                                    <td class="text-center text-bold text-font-1">{{ item.patente }}</td>
                                    <td class="text-center text-bold text-font-1">{{ item.codigo_ticket }}</td>
                                    <td class="text-center text-bold text-font-1">
                                        <span v-html="reducir_texto(item.guias)"></span>
                                    </td>
                                    <td class="text-center text-bold text-font-1">{{ item.fecha_hora_ingreso }}</td>
                                    <td class="text-center text-bold text-font-1">{{ item.empresa }}</td>
                                    <!-- <td class="text-center text-bold text-font-1">
                                    <span v-html="reducir_texto(item.sucursal)"></span>
                                </td> -->
                                    <td class="text-center text-bold text-font-1">{{ item.materia_prima }}</td>
                                    <td class="text-center text-bold text-font-1">{{ item.especie }}</td>
                                    <td class="text-center">
                                        <span v-if="item.restriccion.includes('SI')" class="badge bg-danger"
                                            style="color:#fff;font-size:13px;animation: zoom-in-zoom-out 1s ease infinite;">{{ item.restriccion }}</span>
                                        <span v-if="item.restriccion.includes('NO')" class="badge bg-success"
                                            style="color:#fff;font-size:13px;">{{ item.restriccion }}</span>
                                    </td>
                                    <td class="text-center">
                                        <span class="badge bg-green" style="color:#fff;font-size:13px;"
                                            v-if="item.estado == 'DESCARGADO'"><i class="fas fa-check-square"></i>
                                            {{ item.estado }}</span>
                                        <span class="badge bg-warning" style="color:#fff;font-size:13px;"
                                            v-if="item.estado == 'POR DESCARGAR'"><i class="fas fa-ban"></i>
                                            {{ item.estado }}</span>


                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
    data: () => ({
        lista: []
    }),
    mounted() {
        let nav = document.getElementById("sidenav-main")
        nav.remove()
        this.cargar()
        let that = this;
        setInterval(function () {
            that.cargar();
        }, 10000);

    },
    methods: {
        async cargar() {
            await this.axios.get(`${this.api}/pantalla_patio`).then((res) => {
                this.lista = res.data.data;
                //console.log(res);
            }).catch((e) => {
                console.log(e);
            });
        },
        tiene_restriccion(valor) {
            return valor.includes("SI") ? true : false;
        },
        reducir_texto(valor) {
            let string = ``;
            let array = valor.split('-');
            let count = 0;
            array.forEach(guia => {
                count++;
                string += `${guia}`
                if (count == 2) {
                    count = 0;
                    string += `<br>`;
                }

            });
            return string;
            //return valor.substring(0,10);
        }
    },
    computed: {
        ...mapState(['api'])
    }
}
</script>
<style>
.zoom-in-out-box {
    margin: 24px;
    width: 50px;
    height: 50px;
    background: #f50057;
    animation: zoom-in-zoom-out 1s ease infinite;
}

.bg-salmon {
    background: #f4b1b1 !important;
}

@keyframes zoom-in-zoom-out {
    0% {
        transform: scale(1, 1);
    }

    50% {
        transform: scale(1.5, 1.5);
    }

    100% {
        transform: scale(1, 1);
    }
}
</style>